import React from 'react';
import { FC } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

const CookiesPopup: FC = () => {
  const [cookies, setCookie] = useCookies(['cookieConsent']);

  const navigate = useNavigate();
  const navTo = (path: string) => {
    navigate(path);
  };

  return (
    <>
      {!cookies.cookieConsent && (
        <div className={`fixed bottom-0 left-0 w-full z-30 text-left`}>
          <div className="flex flex-col items-start gap-[16px] px-[96px] py-[34px] lg:!p-[24px] relative bg-[#000000e6]">
            <div className="flex items-center justify-around gap-[16px] self-stretch w-full relative flex-[0_0_auto]">
              <div className="relative flex-1 mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-white text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] [font-style:var(--20-h2-font-style)]">
                本網站使用 cookies
              </div>
            </div>
            <div className="flex lg:flex-col lg:items-end items-start gap-[24px] self-stretch w-full relative flex-[0_0_auto]">
              <div className="relative flex-1 mt-[-1.00px] font-16-h4 font-[number:var(--16-h4-font-weight)] text-[#ffffff] text-[length:var(--16-h4-font-size)] tracking-[var(--16-h4-letter-spacing)] leading-[var(--16-h4-line-height)] [font-style:var(--16-h4-font-style)]">
                點擊「我同意」，即表示您同意我們在您的瀏覽器儲存所有
                Cookies，我們將用於維護網站安全性、改善網站效能、優化使用者體驗、分析使用情形，並用於廣告或行銷。
              </div>
              <div className="inline-flex items-stat gap-[16px] relative flex-[0_0_auto]">
                <button
                  onClick={() => navTo('/privacy-policy')}
                  className="px-6 py-2 bg-white rounded border border-[#CCE9E5] hover:bg-[#EFF9F7] justify-center items-center gap-2.5 flex"
                >
                  <div className="text-center text-[#88CCC3]  text-base font-medium font-['Noto Sans TC'] leading-normal">
                    了解更多
                  </div>
                </button>
                <button
                  className="px-6 py-2 bg-[#88CCC3] hover:bg-[#60BCAE] rounded justify-center items-center gap-2.5 flex"
                  onClick={() => {
                    setCookie('cookieConsent', true, { path: '/' });
                  }}
                >
                  <div className="text-center text-white text-base font-medium font-['Noto Sans TC'] leading-normal">
                    我同意
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default CookiesPopup;
